import axios from "axios";
import { config } from "../config";
import { setServerConfig } from "./apiClient";

let userAccess;

export const getUserPermissions = async (token, userId) => {
    const headers = {
        'Authorization': `Bearer ${token}`,
    };
    const params = {
        uid: userId
    };
    let urlPath = '/api/v2/permissions';
    if (userId) {
        try {
            if (!userAccess) {
                const permissionResp = await axios.get(
                    `${process.env.REACT_APP_SERVERLESS_API_URL}${urlPath}`,
                    {
                        headers: headers,
                        params: params,
                    }
                );
                if (permissionResp && permissionResp.data) {
                    userAccess = permissionResp.data;
                    if (userAccess.serverName) {
                        setServerConfig({
                            serverName: userAccess.serverName,
                            alb: userAccess.alb,
                        });
                    }
                }
            }
            return userAccess;
        } catch (error) {
            console.log(error.message);
            return error.message;
        }
    }
}

export const isAuthorized = (appControlBeingAccessed) => {
    if (
        userAccess && 
        userAccess.permissions && 
        userAccess.permissions.length
    ) {
        if (userAccess.permissions.includes('trade_eval_accounts')) {
            if (
                appControlBeingAccessed === 'connectionScreen' ||
                appControlBeingAccessed === 'tradeScreen' ||
                appControlBeingAccessed === 'tradeEvaluationAccount'
            ) {
                return true;
            }
        }
        if (userAccess.permissions.includes('trade_paid_accounts')) {
            if (appControlBeingAccessed === 'tradePaidAccount') {
                return true;
            }
        } 
        if (userAccess.permissions.includes('trade_live_accounts')) {
            if (appControlBeingAccessed === 'tradeLiveAccount') {
                return true;
            }
        }
        if (userAccess.permissions.includes('admin')) {
            if (appControlBeingAccessed === 'admin') {
                return true;
            }
        }
    }
    return false;
}

export const hasSignedLatestTermsAndConditions = (permissions) => {
    if (
        permissions && 
        permissions.permissions && 
        permissions.permissions.length
    ) {
        if (
            permissions.documents &&
            permissions.documents.length
        ) {
            permissions.documents.sort((a, b) => new Date(b.timestamp).getTime() - new Date(a.timestamp).getTime());
            if (
                permissions.documents[0].termsAndConditionsVersion === config.latestTermsAndConditionsVersion &&
                permissions.documents[0].privacyPolicyVersion === config.latestPrivacyPolicyVersion
            ) {
                return true;
            }
        }
    }
    return false;
    
}